// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2tf0Z","content":"Consent_content__2l_yk","footer":"Consent_footer__2rM1E"};